import "reflect-metadata";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
// import App from './App';
import './styles/index.css';
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

import Loadable from 'react-loadable';
import registerServiceWorker from './registerServiceWorker';
import globalStore from "./models/globalStore";
import {AppToaster} from "./views/toaster";
import {buildNo} from "./config";
import {Spinner} from "@blueprintjs/core";

let AppComponent = null;
const LoadableApp = Loadable({
    loader: () => AppComponent ? Promise.resolve(AppComponent) : globalStore.start().then(() => import('./App')),
    loading() {
        return <div>Загрузка приложения...</div>
    }
});
const LoadableMenuWidgetApp = Loadable({
    loader: () => globalStore.start().then(() => import('./views/MenuWidgetApp')),
    loading() {
        return <a href="/office/" className="nav-link">Личный кабинет</a>
    }
});

const CreatePaymentView = Loadable({
    loader: () => import("./models/payments/paymentsStore")
        .then((paymentsStore: any) => paymentsStore.default.init())
        .then(() => import("./views/payments/CreatePaymentView"))
        .catch(error => () => <div className="error">Ошибка:{String(error)}</div>),
    loading() {
        return <div>
            Загрузка формы
            <Spinner/>
        </div>;
    }
});
const appRoot: HTMLElement = document.getElementById('root');

if (!process.env.REACT_APP_TEST_PAY) {
    if (appRoot) {
        ReactDOM.render(
            [<LoadableApp key="app"/>, <div className="build-no" key="bn">{buildNo}</div>],
            appRoot
        );
    }
}

const formRoot: HTMLElement = document.getElementById('login');
if (formRoot) {
    ReactDOM.render(
        <LoadableMenuWidgetApp/>,
        formRoot
    );
}
const agreeRoot: HTMLElement = document.getElementById('agree');
if(agreeRoot){
    const agreeModule = import("./views/agree");
    agreeModule.then(module=>module.start(agreeRoot));
}

if (process.env.REACT_APP_TEST_PAY) {
    if (appRoot) {
        ReactDOM.render(
            <CreatePaymentView/>,
            appRoot
        );
    }
}else {
    const payCreateFormRoot: HTMLElement = document.getElementById('pay-create-form');

    if (payCreateFormRoot) {
        ReactDOM.render(
            <CreatePaymentView/>,
            payCreateFormRoot
        );
    }
}
if ('serviceWorker' in navigator) {
    registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.tsx